<div class="feedback">
  <app-modal-layout [title]="page?.translation?.data?.modalTitle">
    <form
      [formGroup]="feedbackForm"
      (ngSubmit)="onSubmit()"
      class="feedback-form"
    >
      <div class="feedback-wrapper">
        <mat-form-field>
          <mat-label>{{
            page?.translation?.data?.modalNameOrganization
          }}</mat-label>
          <input matInput formControlName="organisation" required />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ page?.translation?.data?.modalPib }}</mat-label>
          <input matInput formControlName="fullName" required />
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>{{ page?.translation?.data?.modalDesc }}</mat-label>
        <textarea matInput formControlName="description" required></textarea>
      </mat-form-field>

      <div class="file-upload">
        <input
          type="file"
          (change)="onFileSelected($event)"
          hidden
          #fileInput
        />
        <button
          class="file-upload-btn"
          type="button"
          (click)="fileInput.click()"
        >
          <img src="assets/img/icons/upload-icon.svg" alt="upload" />
          {{ page?.translation?.data?.modalFileName }}
        </button>
      </div>
      @if (selectedFile) {
        <span>{{ selectedFile.name }}</span>
      }

      <div class="submit-button">
        <button class="_btn black medium" type="submit">
          {{ page?.translation?.data?.modalBtnApply }}
        </button>
      </div>
    </form>
  </app-modal-layout>
</div>
